<template>
  <div name="demo-export-text">
  	export text
  </div>
</template>

<script>
export default {
  name: 'demo-export-text'
}
</script>


// WEBPACK FOOTER //
// demoExportText.vue?9f5eed02